/* eslint-disable @typescript-eslint/prefer-ts-expect-error */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-console */

'use client'

import { useEffect } from 'react'
import { getPageType } from 'src/helpers/commonHelpers'
import useIdentifyEvent from '@hooks/useIdentityEvent'
import { lobSegmentEventProperties, segmentEventCommonPropFunc } from '@utils/segmentProperties'
import { pageEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import {
  lobSegmentEvents,
  widgetJourney,
  fetchWidgetProductFn,
  fetchVasWidgetType,
} from '@configs/segmentEvents.config'

export function waitForAnalyticsLoad() {
  return new Promise(resolve => {
    const resolver = () => {
      if (window?.acko_analytics && window?.acko_analytics?.anonymousId !== undefined) {
        resolve(void 0)
      } else {
        window.setTimeout(resolver, 300)
      }
    }
    setTimeout(resolver, 300)
  })
}
const AnalyticsViewPage = ({
  segmentEventCommonProperties,
  additionalEventProperties = {},
  isSemPage = false,
  lob,
  widget,
  JourneyData,
}) => {
  useIdentifyEvent()
  useEffect(() => {
    ;(async () => {
      const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
      const viewEventName = lobSegmentEvents?.[getPageType(isSemPage)]?.[lob]?.pageView || 'view_seo_page'
      const widgetType =
        lobSegmentEvents?.[getPageType(isSemPage)]?.[lob]?.widgetType ||
        fetchVasWidgetType?.[widget] ||
        'SEO revamp widget'
      const product = fetchWidgetProductFn?.[widget]?.()
      const journey = widgetJourney?.[widget]

      const additionalLobEventProperties = (await lobSegmentEventProperties[lob]?.(isSemPage)) || {}

      waitForAnalyticsLoad()
        .then(() => {
          pageEvent(viewEventName, {
            ...properties,
            ...(product && { product }),
            ...(journey && { journey }),
            ...additionalLobEventProperties,
            ...additionalEventProperties,
            widget_type: widgetType,
            funnel: JourneyData?.length > 0 ? 'continue_journey' : 'visit',
          })
        })
        .catch(err => {
          console.log('Wait for analytics load error', err)
        })
    })()
  }, [])

  return null
}

export default AnalyticsViewPage
